import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IClassroomLearnersProgressionQueryResult } from "../types/IClassroomLearnersProgression";
import { IClassroomResource } from "../types/IClassroomResource";

export type IClassroomLearnersProgressionQueryParameters = {
    classroom?: RelationalValue<IClassroomResource>;
};

export const classroomLearnersProgressionQuery: IApiQueryFunction<IClassroomLearnersProgressionQueryParameters> = ({
    classroom,
}) => {
    if (!classroom) {
        return;
    }

    return {
        method: "GET",
        url: `/classrooms/${mapRelationalValue(classroom)}/learners-progression`,
    };
};

export const useClassroomLearnersProgressionQuery = createApiQueryHook<
    IClassroomLearnersProgressionQueryParameters,
    IClassroomLearnersProgressionQueryResult
>(classroomLearnersProgressionQuery);
